import { create } from 'zustand';

export const useBillingStore = create((set) => ({
  paywall: {
    isOpen: false,
    tokensRequired: null,
    tokensRemaining: null,
    source: null,
    isGated: false, // true = proactive gate (non-dismissible), false = reactive 402 error
    returnTo: null,
  },
  openPaywall: (payload = {}) =>
    set({
      paywall: {
        isOpen: true,
        tokensRequired:
          payload.tokensRequired !== undefined ? payload.tokensRequired : null,
        tokensRemaining:
          payload.tokensRemaining !== undefined ? payload.tokensRemaining : null,
        source: payload.source || null,
        isGated: payload.isGated || false,
        returnTo: payload.returnTo || null,
      }
    }),
  closePaywall: () =>
    set({
      paywall: {
        isOpen: false,
        tokensRequired: null,
        tokensRemaining: null,
        source: null,
        isGated: false,
        returnTo: null,
      }
    })
}));

